import React, { useState } from 'react';
import { QRCode } from 'react-qrcode-logo'; // QR Code generator
import logo from '../assets/logo.png'; // Logo for QR Code
import './CSS/Login.css';

const QRCodeGenerator = () => {
  const [url, setUrl] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');

  const handleGenerateQRCode = () => {
    setQrCodeUrl(url);
  };

  return (
    <div className="qr-container d-flex align-items-center justify-content-center">
      <div className="text-center">
        <img className="logo" src={logo} alt="Logo" />
        <h2>Generate QR Code for a URL</h2>
        <div className="row justify-content-center">
          <div className="col-sm-8">
            <div className="card">
              <div className="card-body">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter URL here"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                />
                <button onClick={handleGenerateQRCode} className="btn btn-dark mt-3">
                  Generate QR Code
                </button>

                {qrCodeUrl && (
                  <div className="mt-4">
                    <h4>QR Code</h4>
                    <QRCode
                      value={qrCodeUrl}
                      size={250}
                      logoImage={logo}
                      logoWidth={70} // Increased logo size
                      logoHeight={70} // Increased logo size
                      qrStyle="dots"
                      eyeRadius={10}
                    />
                    <p className="small">Scan the QR code to visit the URL</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;
